import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJiraLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 630 630",
	style: { enableBackground: "new 0 0 630 630" },
	xmlSpace: "preserve",
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\r\n	.st0{fill:#0052CC;}\r\n	.st1{fill:#FFFFFF;}\r\n	.st2{fill:url(#SVGID_1_);}\r\n	.st3{fill:url(#SVGID_00000106850651215171117030000000559603045466457216_);}\r\n"
		}),
		/* @__PURE__ */ _jsx("rect", {
			className: "st0",
			width: 630,
			height: 630
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M528.3,302.4L333.8,107.9L315,89L168.6,235.4l-66.9,66.9c-7,7-7,18.3,0,25.3l133.8,133.8L315,541l146.4-146.4 l2.3-2.3l64.7-64.6C535.3,320.8,535.4,309.4,528.3,302.4C528.4,302.4,528.3,302.4,528.3,302.4L528.3,302.4L528.3,302.4z M315,381.8 L248.1,315l66.8-66.8l66.8,66.8L315,381.8L315,381.8z"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SVGID_1_",
			gradientUnits: "userSpaceOnUse",
			x1: 346.936,
			y1: 156.5632,
			x2: 252.846,
			y2: 64.0232,
			gradientTransform: "matrix(1 0 0 -1 0 294)",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: 0,
					style: { stopColor: "#0052CC" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .03,
					style: { stopColor: "#0D5BCE" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .19,
					style: { stopColor: "#4C85DB" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .35,
					style: { stopColor: "#82AAE6" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .5,
					style: { stopColor: "#AFC9EF" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .64,
					style: { stopColor: "#D2E0F6" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .78,
					style: { stopColor: "#EAF1FA" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .9,
					style: { stopColor: "#F9FBFD" }
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					style: { stopColor: "#FFFFFF" }
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M315,247.9c-43.8-43.7-44-114.6-0.5-158.6L168.3,235.4l79.6,79.6L315,247.9z"
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "SVGID_00000081630068373304583670000008109979206682089400_",
			gradientUnits: "userSpaceOnUse",
			x1: 276.3912,
			y1: -206.1569,
			x2: 369.5312,
			y2: -113.0369,
			gradientTransform: "matrix(1 0 0 -1 0 294)",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: 0,
				style: { stopColor: "#0052CC" }
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				style: { stopColor: "#FFFFFF" }
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			style: { fill: "url(#SVGID_00000081630068373304583670000008109979206682089400_)" },
			d: "M382,315l-67,67 c43.9,44,43.9,115.2,0,159.1l146.6-146.6L382,315L382,315z"
		})
	]
});
export { SvgJiraLogo as ReactComponent };
